import { render, staticRenderFns } from "./TemplateSelected.vue?vue&type=template&id=680bfaf4&scoped=true&"
import script from "./TemplateSelected.vue?vue&type=script&lang=js&"
export * from "./TemplateSelected.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSelected.vue?vue&type=style&index=0&id=680bfaf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680bfaf4",
  null
  
)

export default component.exports